import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import OtpProviderForm from '@/modules/otp-provider/components/OtpProviderForm'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'

function CreateOtpProviderPage() {
	const navigate = useNavigate()

	const handleSuccess = () => {
		navigate('/operator/otp-provider')
	}

	const handleBack = () => {
		navigate('/operator/otp-provider')
	}

	return (
		<PageContainer>
			<div className="mx-auto max-w-2xl">
				<div className="mb-6 flex items-center gap-4">
					<Button variant="outline" size="sm" onClick={handleBack}>
						<ArrowLeft className="mr-2 h-4 w-4" />
						กลับ
					</Button>
					<h1 className="text-2xl font-semibold">เพิ่มผู้ให้บริการ OTP</h1>
				</div>
				<OtpProviderForm mode="create" onSuccess={handleSuccess} />
			</div>
		</PageContainer>
	)
}

export default withUserPermission(CreateOtpProviderPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})
